$(function () {
    $(".js-accordion").each(function () {
        $(this).accordionjs({
            closeAble: true,
            closeOther: false,
            activeIndex: 1,
        });
    });
});
